import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { BarclaycardApplePayComponentDef } from '@df/module-barclaycard/apple-pay/barclaycard-apple-pay.component.def';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ProductStockDescriptionService } from '../../../catalog/product/stock-levels/product-stock-description.service';
import { CheckoutFormComponent } from '../../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from '../../../checkout/step/checkout-step.component';
import { ResultComponent } from '../../../ui/api/result.component';

@Component({
    selector: 'barclaycard-apple-pay',
    templateUrl: './barclaycard-apple-pay.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ResultComponent, TranslationModule]
})
export class BarclaycardApplePayComponent extends BarclaycardApplePayComponentDef {
    constructor(
        protected override checkoutFormComponent: CheckoutFormComponent,
        protected override checkoutStepComponent: CheckoutStepComponent,
        protected override changeDetectorRef: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        private productStockDescriptionService: ProductStockDescriptionService
    ) {
        super(checkoutFormComponent, changeDetectorRef, scrollToService, checkoutStepComponent);
    }

    override submit() {
        this.productStockDescriptionService.saveBasketLeadTimes();
        super.submit();
    }
}
